<template>
  <b-sidebar
    id="add-snapshot-sidebar"
    :visible="isSnapShotSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('clicked', false)"
    @change="(val) => $emit('one')"
  >
    <template>
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">SnapShot</h5>
      </div>

     <div class="align-items-center px-2 py-1">
    
    <!-- Camera Resolution Display -->
    <div v-if="cameraResolution" class="text-center text-muted mb-1" style="font-size: 0.95rem;">
      目前相機解析度：{{ cameraResolution }}
    </div>

    <!-- 鏡頭或相片預覽 -->
    <div class="text-center mb-2">
      <v-easy-camera
        v-model="picture"
        ref="cam"
        v-show="!picture"
        :startOnMounted="startOnMounted"
        :autoDetectMobile="startOnMounted"
        :v-bind="{
          videoConstraints: {
            width: { min: 1280, ideal: 1920 },
            height: { min: 720, ideal: 1080 },
            facingMode: 'user',
            frameRate: { ideal: 30, max: 60 }
          }
        }"
        class="mb-5"
      />
      <canvas ref="overlay" class="camera-overlay" v-if="!image_upload && !picture"></canvas>
      <img v-if="picture" :src="picture" style="max-width: 100%;" />
    </div>

        <!-- 狀態 -->
        <div v-if="picture == null" class="text-center" style="font-size: 1.2rem;">
          <span :style="{ color: faceDetected ? 'green' : 'red' }">
            
          </span>
        </div>

        <!-- Capture -->
        <b-button
          variant="primary"
          @click="capture"
          size="lg"
          style="padding:4rem 2rem"
          block
          v-if="!picture"
        >
          Capture
        </b-button>

        <!-- Upload：若無人樣 → 禁用 -->
        <b-button
          variant="danger"
          @click="upload"
          block
          class="my-2"
          v-if="picture"
        >
          Upload
        </b-button>

        <hr class="my-2"/>

        <!-- 上傳圖片 -->
        <b-form-file
          id="wildcard"
          @change="onFileSelected"
          accept="image/*"
        />

        <b-button
          variant="outline-primary"
          @click="switch_cam"
          block
          v-if="!image_upload && !picture"
          class="my-2"
        >
          Switch Camera
        </b-button>

        <b-button
          variant="warning"
          class="my-1"
          @click="start"
          block
        >
          Start Camera
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BButton, BFormFile,
} from 'bootstrap-vue'
import EasyCamera from 'easy-vue-camera'
import * as faceapi from 'face-api.js'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ToastificationContent,
    BSidebar,
    BFormFile,
    BButton,
    'v-easy-camera': EasyCamera,
  },
  watch: {
  isSnapShotSidebarActive(val) {
    if (val) {
      // sidebar 打開 → 延遲啟動鏡頭
      setTimeout(() => {
        this.start()
      }, 500)
    } else {
      // sidebar 關閉 → 停止鏡頭
      if (this.$refs.cam) this.$refs.cam.stop()
      this.picture = null
    }
  }
},
  props: {
    isSnapShotSidebarActive: Boolean,
    userType: String,
    userData: Object,
  },
  data() {
    return {
      picture: null,
      startOnMounted: false,
      image_upload: false,
      faceDetected: false,
      detectionInterval: null,
      cameraResolution: null, // 👈 新增顯示解析度
      modelsLoaded: false,
    }
  },
  beforeDestroy() {
    if (this.detectionInterval) clearInterval(this.detectionInterval)
  },
  created() {
    this.loadModels()
  },
  methods: {
    async loadModels() {
      const MODEL_URL = '/models'
      console.log('📦 載入人臉模型中...')
      await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL)
      console.log('✅ 模型載入完成')
      this.modelsLoaded = true
    },

async start() {
  this.picture = null
  if (!this.modelsLoaded) {
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '模型未載入',
        icon: 'XIcon',
        variant: 'danger',
        text: '請稍等幾秒後重試。',
      },
    })
    return
  }

  await this.$nextTick()
  const cam = this.$refs.cam
  if (!cam) {
    console.warn('⚠️ Camera 元件未就緒')
    return
  }

  try {
    await cam.start()
    console.log('📸 Camera Started')
    this.startDetection()

    // 🆕 等 video 初始化完畢後取實際 resolution
    const videoEl = cam.$el.querySelector('video')
    if (videoEl) {
      videoEl.onloadedmetadata = () => {
        this.cameraResolution = `${videoEl.videoWidth} x ${videoEl.videoHeight}`
        console.log('🎥 相機解析度：', this.cameraResolution)
      }
    }
  } catch (err) {
    console.error('❌ 開啟鏡頭失敗：', err)
  }
},





async startDetection() {
  const videoEl = this.$refs.cam?.$el?.querySelector('video')
  const canvas = this.$refs.overlay

  if (!videoEl || !canvas) {
    console.warn('⚠️ 無法啟動偵測：相機或畫布未就緒')
    return
  }

  // 📸 等相機真正 ready（避免手機延遲）
  await new Promise(resolve => {
    const checkReady = setInterval(() => {
      if (videoEl.readyState === 4 && videoEl.videoWidth > 0) {
        clearInterval(checkReady)
        resolve()
      }
    }, 200)
  })

  // 🧭 取得實際顯示大小，確保框線貼住畫面
  const rect = videoEl.getBoundingClientRect()
  const displaySize = { width: rect.width, height: rect.height }

  // 🖼️ Canvas 對齊畫面大小
  canvas.width = rect.width
  canvas.height = rect.height
  faceapi.matchDimensions(canvas, displaySize)

  const ctx = canvas.getContext('2d')

  // 🔁 清除舊的 interval
  if (this.detectionInterval) clearInterval(this.detectionInterval)

  console.log(`📷 啟動偵測 (${displaySize.width}x${displaySize.height})`)

  // 🔍 開始人臉偵測循環
  this.detectionInterval = setInterval(async () => {
    if (videoEl.readyState !== 4) return

    try {
      const detections = await faceapi.detectAllFaces(
        videoEl,
        new faceapi.TinyFaceDetectorOptions({
          inputSize: 512,        // 偵測精度
          scoreThreshold: 0.5,   // 信心門檻
        })
      )

      // 清除舊框線
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      // 對應實際畫面大小（唔用 videoWidth，避免偏移）
      const resized = faceapi.resizeResults(detections, displaySize)
      //faceapi.draw.drawDetections(canvas, resized)

      // 更新人臉狀態
      this.faceDetected = detections.length > 0

      if (detections.length > 0) {
        const confidence = (detections[0].score * 100).toFixed(1)
        console.log(`🧠 偵測到人臉，信心值：${confidence}%`)
      }
    } catch (err) {
      console.error('❌ 偵測過程錯誤：', err)
    }
  }, 200)
},




    onFileSelected(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.picture = e.target.result
          this.image_upload = true
          this.faceDetected = true // 假設上載後可允許上傳
        }
        reader.readAsDataURL(file)
      }
    },
async capture() {
  try {
    // 1️⃣ 拍照
    this.$refs.cam.snap()
    this.$refs.cam.stop()
    console.log('📸 已拍照，準備偵測人臉...')

    // 2️⃣ 確保有圖片
    await this.$nextTick()
    if (!this.picture) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: '拍照失敗',
          icon: 'XIcon',
          variant: 'danger',
          text: '未能取得相片，請重試。',
        },
      })
      return
    }

    // 3️⃣ 偵測人臉
    const img = await faceapi.fetchImage(this.picture)
    const detections = await faceapi.detectAllFaces(
      img,
      new faceapi.TinyFaceDetectorOptions({ inputSize: 512, scoreThreshold: 0.5 })
    )

    if (detections.length === 0) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: '未偵測到人臉',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
          text: '請確保鏡頭前有人樣再重拍。',
        },
      })
      this.picture = null
      return
    }

    // 4️⃣ 取第一個人臉
    const bestFace = detections[0]
    const { box, score } = bestFace

    // 檢查人臉尺寸
    if (box.width < 100) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: '人臉太細',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
          text: `偵測到人臉寬度只有 ${box.width.toFixed(0)}px，請靠近鏡頭再拍。`,
        },
      })
      this.picture = null
      return
    }

    // 5️⃣ 加 margin 裁剪
    const marginTop = 120
    const marginSide = 40
    const x = Math.max(box.x - marginSide, 0)
    const y = Math.max(box.y - marginTop, 0)
    const width = box.width + marginSide * 2
    const height = box.height + marginTop + marginSide

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.width = width
    canvas.height = height
    ctx.drawImage(img, x, y, width, height, 0, 0, width, height)
    const croppedBase64 = canvas.toDataURL('image/jpeg')

    // 6️⃣ 更新結果 (顯示裁剪後圖片)
    this.picture = croppedBase64
    this.faceDetected = true

    // 7️⃣ 顯示分數 + 預覽
    const scoreFixed = (score * 100).toFixed(2)
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '人臉偵測成功',
        icon: 'SmileIcon',
        variant: score >= 0.85 ? 'success' : 'warning',
        text: `信心值：${scoreFixed}% — 已顯示裁剪後圖片`,
      },
    })
    console.log(`✅ 偵測成功：信心 ${scoreFixed}%`)
  } catch (err) {
    console.error('❌ 偵測錯誤:', err)
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '偵測失敗',
        icon: 'XIcon',
        variant: 'danger',
        text: '無法分析人臉，請重試。',
      },
    })
  }
},
    switch_cam() {
      this.$refs.cam.switchCamera()
    },
   async resetCamera() {
  this.picture = null
  this.image_upload = false
  this.faceDetected = false

  const canvas = this.$refs.overlay
  if (canvas) {
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, canvas.width, canvas.height)
  }

  // 等 Vue 將 camera 元件重新渲染
  await this.$nextTick()

  // 稍等半秒再啟動
  setTimeout(async () => {
    const cam = this.$refs.cam
    if (cam) {
      try {
        await cam.start()
        this.startDetection()
        console.log('🔄 Camera 已重置並重新啟動')
      } catch (e) {
        console.warn('⚠️ 無法重新開啟相機：', e)
      }
    } else {
      console.warn('⚠️ Camera 元件未就緒（尚未 mounted）')
    }
  }, 500)
},
async upload() {
  if (!this.picture) {
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '未有相片',
        icon: 'AlertTriangleIcon',
        variant: 'warning',
        text: '請先拍攝或上載相片。',
      },
    })
    return
  }

  if (!this.modelsLoaded) {
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '模型未載入',
        icon: 'XIcon',
        variant: 'danger',
        text: '請稍等幾秒後重試。',
      },
    })
    return
  }

  // 👇 上載前做人臉偵測 + 信心值檢查
  try {
    const img = await faceapi.fetchImage(this.picture)
    const detections = await faceapi.detectAllFaces(
      img,
      new faceapi.TinyFaceDetectorOptions({ inputSize: 512, scoreThreshold: 0.5 })
    )

    // if (detections.length === 0) {
    //   this.$toast({
    //     component: ToastificationContent,
    //     props: {
    //       title: '未偵測到人臉',
    //       icon: 'AlertTriangleIcon',
    //       variant: 'warning',
    //       text: '請確保相片內有人樣先上載。',
    //     },
    //   })
    //   return
    // }

    // 取得最高信心值
    const maxScore = Math.max(...detections.map(d => d.score))
    console.log(`🧠 偵測信心分數: ${maxScore.toFixed(3)}`)
    // this.$toast({
    //     component: ToastificationContent,
    //     props: {
    //       title: '人臉分數',
    //       icon: 'AlertTriangleIcon',
    //       variant: 'information',
    //       text: `偵測值 (${maxScore.toFixed(2)}) 。`,
    //     },
    //   })
    // if (maxScore < 0.9) {
    //   this.$toast({
    //     component: ToastificationContent,
    //     props: {
    //       title: '人臉分數不足',
    //       icon: 'AlertTriangleIcon',
    //       variant: 'warning',
    //       text: `偵測值 (${maxScore.toFixed(2)}) 太低，請重新拍攝。`,
    //     },
    //   })
    //   return
    // }
  } catch (err) {
    console.error('❌ 偵測錯誤:', err)
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '偵測失敗',
        icon: 'XIcon',
        variant: 'danger',
        text: '無法分析人臉，請重試。',
      },
    })
    return
  }

  // ✅ 通過人臉偵測與信心值 → 上載
  const data = {
    type: this.userType,
    base64: this.picture,
    token: this.userData.token,
  }

  try {
    const res = await this.$http.post(
      `${process.env.VUE_APP_API_BASE}/member/${this.userData.member_id}/snapshot/`,
      data
    )

    if (res.data.result === true) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: '上載成功',
          icon: 'CheckIcon',
          variant: 'success',
          text: '相片已成功上載。',
        },
      })

      // ✅ 只喺成功時 reset
      this.resetCamera()
      this.$emit('clicked', false)
    } else {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: '上載失敗',
          icon: 'XIcon',
          variant: 'danger',
          text: res.data.message,
        },
      })
    }
  } catch (error) {
    console.error('❌ 上載錯誤:', error)
    this.$toast({
      component: ToastificationContent,
      props: {
        title: '上載錯誤',
        icon: 'XIcon',
        variant: 'danger',
        text: '伺服器無法上載相片。',
      },
    })
  }
}


  },
}
</script>

<style scoped>
.camera-wrapper {
  position: relative;
  display: inline-block;
}
.camera-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 300px;
  pointer-events: none;
}
</style>
